import { ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  Paper,
  Box,
  Typography,
  IconButton,
  SelectChangeEvent,
} from "@mui/material";
import { FC, useEffect, useState } from "react";
import { DropDown } from "../../../common/components/DropDown";
import { Option } from "../../../common/interface/interface";
import { useFieldGraphData } from "../../../common/hooks/useFieldGraphData";
import { DataTable } from "../../../common/components/DataTable";

interface Props {
  selectedFields: Option[];
  areaTag: string;
}

export const RawDataTable: FC<Props> = ({ areaTag, selectedFields }) => {
  const [dataTableExpanded, setDataTableExpanded] = useState<boolean>(false);
  const [selectedAreaFields, setSelectedAreaFields] = useState(selectedFields);
  const { rawFieldData, isloading } = useFieldGraphData(
    areaTag,
    selectedAreaFields[0]?.value || "",
    //TODO pass date range
    "2025-06-01T23:59:59Z",
    "now()"
  );

  useEffect(() => {
    if (selectedFields.length > 0) {
      setSelectedAreaFields([selectedFields[0]]);
    }
  }, [selectedFields]);

  const handleSelectedAreaFields = (e: SelectChangeEvent<string>) => {
    const value = e.target.value;

    const selectedOption = selectedFields.find((opt) => opt.value === value);
    if (selectedOption) {
      setSelectedAreaFields([selectedOption]);
    }
  };

  return (
    <>
      <Paper sx={{ p: 3, borderRadius: 3, mt: 3, mb: 2 }}>
        <Box sx={{ mb: 2, display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Raw Channel Data
          </Typography>

          <DropDown
            options={selectedFields}
            value={selectedAreaFields[0]?.value || ""}
            onChange={handleSelectedAreaFields}
            name="Fields"
          />
          <IconButton
            onClick={() => setDataTableExpanded((prev) => !prev)}
            size="small"
            sx={{ ml: "auto" }}
          >
            {dataTableExpanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </Box>
        {dataTableExpanded && (
          <DataTable
            data={rawFieldData}
            isAccordion={false}
            loading={isloading}
          />
        )}
      </Paper>
    </>
  );
};
